// ExtraContent.js
import React from 'react';
const ExtraContent = () => {

};
export default ExtraContent;

/* import React, { useEffect } from 'react';
import './ExtraContent.css';
import Coach from './Coach.png';
import MindMap from './MindMap.png';
import Insights from './Insights.png';
import Assessments from './Assessments.png';

// Social Proof Banner (same as before)
const reviews = [
  { id: 1, text: "Vybly helps me break down what's stressing me out, and the advice is so on point.", reviewer: "Alejandro", stars: 5 },
  { id: 2, text: "I used Vybly to prep for a tough meeting and it legit boosted my confidence.", reviewer: "Jamie", stars: 5 },
  { id: 3, text: "Whenever I’m overwhelmed, I use Vybly to make sense of my ideas and actually get stuff done.", reviewer: "Morgan", stars: 5 },
  { id: 4, text: "I'm obsessed with the quizzes and insights. Never seen my brain mapped like this before.", reviewer: "Taylor", stars: 5 },
  { id: 5, text: "Mind Map showed me solutions I never would have come up with by myself. Seriously useful.", reviewer: "Tariq", stars: 5 },
  { id: 6, text: "If you’re overthinking, stuck, or just need to organize your brain, Vybly is a lifesaver.", reviewer: "Priya", stars: 5 },
  { id: 7, text: "It's the only app that helps me see patterns in my thinking, not just dump notes.", reviewer: "Hana", stars: 5 },
  { id: 8, text: "Feels like having a therapist, coach, and hype squad in my pocket (minus the awkwardness).", reviewer: "Darius", stars: 5 },
  { id: 9, text: "Love how Vybly breaks down my thoughts and turns chaos into something I can actually handle.", reviewer: "Kayla", stars: 5 },
];

const StarRating = ({ count }) => (
  <div className="star-rating">
    {"★".repeat(count)}
  </div>
);

const SocialProofBanner = () => (
  <div className="social-proof-banner">
    <div className="reviews-track">
      {reviews.concat(reviews).map(review => (
        <div key={review.id + '-' + Math.random()} className="review">
          <StarRating count={review.stars} />
          <p className="review-text">"{review.text}"</p>
          <p className="reviewer">- {review.reviewer}</p>
        </div>
      ))}
    </div>
  </div>
);

// Data for features – replace with your own images and text later.
const features = [
  {
    title: "Personal AI Coach",
    text: "Get in the ring with your own excuses. Vybly asks what you’re avoiding, what you want to do about it, and what you’ll do next. No sugar-coating.",
    image: Coach
  },
  {
    title: "Interactive Mind Map",
    text: "Dump all your open loops, side hustles, hang-ups, or ambitions. See every thought, worry, or half-formed plan—then start cleaning house.",
    image: MindMap
  },
  {
    title: "Insights Log",
    text: "Spot the patterns that run your life. See where you self-sabotage, what fires you up, and track your momentum in black and white.",
    image: Insights
  },
  {
    title: "Deep Assessments",
    text: "Built on research, made personal — to help you understand your strengths, blind spots, and where to grow next.",
    image: Assessments
  }
];

const FeaturesSection = () => {
  useEffect(() => {
    const featureElements = document.querySelectorAll('.feature-item');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    featureElements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="features-section">

      <div className="beam-overlay"></div>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-item organic">
            <div className="feature-img" style={{ backgroundImage: `url(${feature.image})` }} />
            <div className="feature-info">
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const BottomButton = () => {
  const scrollToQuiz = () => {
    const quizSection = document.getElementById('quiz-section');
    if (quizSection) {
      quizSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bottom-button-container">
      <button className="bottom-btn" onClick={scrollToQuiz}>
        Get Started
      </button>
    </div>
  );
};

const ExtraContent = () => {
  return (
    <div className="extra-content">
      <SocialProofBanner />
      <FeaturesSection />
      <BottomButton />
    </div>
  );
};

export default ExtraContent; */
